(function(){
"use strict";
var C = "https://cdn.shopify.com/s/files/1/0828/4464/7683/files/";

/* ---------- hero gallery ---------- */
var GAL = [
{f:"Foto_1.webp",  alt:"Fable Juice blender with fresh fruit"},
{f:"Foto_10.webp", alt:"Blender filled with strawberries"},
{f:"Foto_12.webp", alt:"Blending fresh fruit"},
{f:"Foto_3.webp",  alt:"Fable Juice blender and strawberries"},
{f:"Foto_5.webp",  alt:"Wireless charging dock"},
{f:"Foto_16.webp", alt:"Fresh orange juice in the bottle"},
{f:"Foto_11.webp", alt:"Blender with whole ingredients"},
{f:"Foto_13.webp", alt:"Fable Juice blender styled"},
{f:"Foto_9.webp",  alt:"How to use in a few simple steps"},
{f:"Foto_14.webp", alt:"Battery and charging options"}
];
var track = document.getElementById('galTrack');
var dots  = document.getElementById('galDots');
var thumbs= document.getElementById('galThumbs');
var vp    = document.getElementById('galViewport');
var idx = 0, timer = null;
if(track){
GAL.forEach(function(g, i){
var s = document.createElement('div');
s.className = 'gal-slide';
var im = document.createElement('img');
im.src = C + g.f + '?width=900';
im.srcset = C+g.f+'?width=500 500w, '+C+g.f+'?width=900 900w, '+C+g.f+'?width=1300 1300w';
im.sizes = '(min-width:1040px) 46vw, 100vw';
im.alt = g.alt;
im.width = 900; im.height = 900;
if(i > 0){ im.loading = 'lazy'; } else { im.fetchPriority = 'high'; }
s.appendChild(im);
track.appendChild(s);
var d = document.createElement('i');
d.addEventListener('click', function(){ go(i); });
dots.appendChild(d);
var t = document.createElement('div');
t.className = 't';
var ti = document.createElement('img');
ti.src = C + g.f + '?width=140'; ti.alt = ''; ti.loading = 'lazy';
t.appendChild(ti);
t.addEventListener('click', function(){ go(i); });
thumbs.appendChild(t);
});
}
function paintGal(){
if(!track) return;
track.style.transform = 'translateX(' + (-idx * 100) + '%)';
var ds = dots.children, ts = thumbs.children;
for(var i=0;i<ds.length;i++){
ds[i].className = (i===idx) ? 'on' : '';
ts[i].className = (i===idx) ? 't on' : 't';
}
}
function go(i){ idx = (i + GAL.length) % GAL.length; paintGal(); restart(); }
function restart(){ clearInterval(timer); timer = setInterval(function(){ go(idx+1); }, 5000); }
var gp=document.getElementById('galPrev'), gn=document.getElementById('galNext');
if(gp) gp.addEventListener('click', function(){ go(idx-1); });
if(gn) gn.addEventListener('click', function(){ go(idx+1); });
var sx = 0, sy = 0, swiping = false;
if(vp){
vp.addEventListener('touchstart', function(e){
sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
}, {passive:true});
vp.addEventListener('touchend', function(e){
if(!swiping) return; swiping = false;
var dx = e.changedTouches[0].clientX - sx;
var dy = e.changedTouches[0].clientY - sy;
if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1));
}, {passive:true});
}
paintGal(); restart();

/* ---------- UGC belts ---------- */
var CLIPS = ["Video_1_Carrosel.webp","Video_2_Carrosel.webp","Video_3_Carrosel.webp",
"Video_4_Carrosel.webp","Video_5_carrosel.webp","Video_6_carrosel.webp"];
function fillBelt(el, list){
if(!el) return;
list.concat(list).forEach(function(f){
var t = document.createElement('div');
t.className = 'belt-tile';
var im = document.createElement('img');
im.src = C + f; im.alt = ''; im.loading = 'lazy';
im.width = 270; im.height = 480;
t.appendChild(im);
el.appendChild(t);
});
}
fillBelt(document.getElementById('beltTop'), CLIPS);
fillBelt(document.getElementById('beltBottom'), CLIPS.slice().reverse());

/* ---------- FAQ accordions ---------- */
document.querySelectorAll('.faq-item').forEach(function(item){
var q = item.querySelector('.faq-q');
var a = item.querySelector('.faq-a');
if(!q || !a) return;
q.addEventListener('click', function(){
var open = item.classList.contains('open');
var group = item.closest('.faq-cols, .faq-list') || document;
group.querySelectorAll('.faq-item').forEach(function(i){
i.classList.remove('open');
var aa = i.querySelector('.faq-a');
if(aa) aa.style.maxHeight = null;
});
if(!open){ item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
});
});

/* ---------- sticky bar ----------
   Horizon scrolls inside .page-wrapper and html/body are overflow:hidden,
   so window scroll events never fire here. Use IntersectionObserver. */
(function(){
var sticky = document.getElementById('stickyAtc');
var hero   = document.querySelector('.fable-juice-landing .hero');
var offer  = document.getElementById('offer');
if(!sticky || !hero || !offer || !('IntersectionObserver' in window)) return;
var pastHero=false, onOffer=false;
function apply(){ sticky.classList.toggle('show', pastHero && !onOffer); }
new IntersectionObserver(function(en){ pastHero = !en[0].isIntersecting; apply(); },{threshold:0}).observe(hero);
new IntersectionObserver(function(en){ onOffer = en[0].isIntersecting; apply(); },{threshold:0}).observe(offer);
})();

/* ---------- anchor scroll (works inside a nested scroll container) ---------- */
document.addEventListener('click', function(e){
var a = e.target.closest('a[href="#offer"]');
if(!a) return;
e.preventDefault();
var o = document.getElementById('offer');
if(o) o.scrollIntoView({behavior:'smooth', block:'start'});
});

/* ---------- variants + cart ---------- */
var FJ = window.FJ_DATA || {variants:[]};
function money(c){ return '$'+(c/100).toFixed(2).replace(/\.00$/,''); }
function state(){
var c=document.querySelector('.fj-swatch.on');
var k=document.querySelector('.kit-option.selected');
return {color: c?c.dataset.color:null, kit: k?k.dataset.kit:null};
}
function find(color,kit){
for(var i=0;i<FJ.variants.length;i++){
var v=FJ.variants[i];
if(v.color===color && v.kit===kit) return v;
}
return null;
}
function paintKits(){
var color=state().color;
document.querySelectorAll('[data-kitprice]').forEach(function(box){
var v=find(color, box.getAttribute('data-kitprice'));
var opt=box.closest('.kit-option');
if(!v){ if(opt) opt.classList.add('soldout'); return; }
if(opt) opt.classList.toggle('soldout', !v.available);
box.querySelector('.now').textContent = money(v.price);
box.querySelector('.per').textContent = v.qty>1 ? money(Math.round(v.price/v.qty))+' each' : '';
box.querySelector('.was').textContent = v.compare>v.price ? money(v.compare) : '';
});
}
function paint(){
var s=state(), v=find(s.color,s.kit);
paintKits();
if(v){
var hp=document.getElementById('heroPrice'), hw=document.getElementById('heroWas');
var sp=document.getElementById('saPrice'), sw=document.getElementById('saWas');
if(hp) hp.textContent=money(v.price);
if(hw) hw.textContent = v.compare>v.price ? money(v.compare) : '';
if(sp) sp.textContent=money(v.price);
if(sw) sw.textContent = v.compare>v.price ? money(v.compare) : '';
}
document.querySelectorAll('[data-atc]').forEach(function(b){
b.disabled = !(v && v.available);
if(b.dataset.busy!=='1') b.textContent = (v && v.available) ? 'Add To Cart' : 'Sold out';
});
}
document.addEventListener('click', function(e){
var sw=e.target.closest('.fj-swatch');
if(sw){
document.querySelectorAll('.fj-swatch').forEach(function(x){ x.classList.toggle('on', x.dataset.color===sw.dataset.color); });
paint(); return;
}
var ko=e.target.closest('.kit-option');
if(ko && !ko.classList.contains('soldout')){
document.querySelectorAll('.kit-option').forEach(function(x){ x.classList.toggle('selected', x.dataset.kit===ko.dataset.kit); });
paint(); return;
}
});

/* the header cart count lives in a section whose id carries a per-theme hash,
   so resolve it from the DOM rather than hardcoding it */
function sectionIdOf(el){
var n=el;
while(n){ if(n.id && n.id.indexOf('shopify-section-')===0) return n.id.replace('shopify-section-',''); n=n.parentElement; }
return null;
}
function cartSectionIds(){
var ids=[];
if(document.getElementById('shopify-section-cart-drawer-section')) ids.push('cart-drawer-section');
var anchor=document.getElementById('cart-bubble-text')||document.querySelector('cart-icon');
if(anchor){ var id=sectionIdOf(anchor); if(id && ids.indexOf(id)<0) ids.push(id); }
return ids.join(',');
}
function swapSections(sections){
if(!sections) return;
Object.keys(sections).forEach(function(id){
var target=document.getElementById('shopify-section-'+id);
if(!target) return;
var doc=new DOMParser().parseFromString(sections[id],'text/html');
var fresh=doc.getElementById('shopify-section-'+id);
if(fresh) target.innerHTML=fresh.innerHTML;
});
}
function openDrawer(){
var d=document.getElementById('cart-drawer');
if(d && typeof d.open==='function'){ try{ d.open(); return true; }catch(err){} }
return false;
}
function syncBubble(){
fetch('/cart.js',{headers:{'Accept':'application/json'}})
.then(function(r){ return r.json(); })
.then(function(cart){
var b=document.getElementById('cart-bubble-text');
if(b) b.textContent=cart.item_count;
})
.catch(function(){});
}
document.addEventListener('click', function(e){
var btn=e.target.closest('[data-atc]');
if(!btn || btn.disabled) return;
e.preventDefault();
var s=state(), v=find(s.color,s.kit);
var note=btn.parentNode.querySelector('.fj-note');
if(note){ note.textContent=''; note.classList.remove('err'); }
if(!v || !v.available) return;
btn.dataset.busy='1'; btn.disabled=true; btn.textContent='Adding...';
fetch('/cart/add.js',{
method:'POST',
headers:{'Content-Type':'application/json','Accept':'application/json'},
body: JSON.stringify({ items:[{id:v.id, quantity:1}], sections: cartSectionIds(), sections_url: window.location.pathname })
})
.then(function(r){
if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||'Could not add to cart'); });
return r.json();
})
.then(function(data){
swapSections(data.sections);
syncBubble();
document.documentElement.dispatchEvent(new CustomEvent('cart:update',{bubbles:true}));
document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
btn.textContent='Added';
if(!openDrawer()){ window.location.href='/cart'; return; }
setTimeout(function(){ btn.dataset.busy=''; btn.disabled=false; paint(); }, 1400);
})
.catch(function(err){
btn.dataset.busy=''; btn.disabled=false; paint();
if(note){ note.textContent=(err&&err.message)?err.message:'Could not add to cart. Please try again.'; note.classList.add('err'); }
});
});

paint();
})();